import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import { Blockquote, CodeBlock, Heading, HorizontalRule, OrderedList, BulletList, ListItem, TodoItem, TodoList, Bold, Code, Italic, Strike, Underline, History, Image, Link } from 'tiptap-extensions'

export default {
  name: 'TextEditor',
  components: {
    EditorContent,
    EditorMenuBar
  },
  props: ['value', 'disabled'],
  data () {
    return {
      content: '',
      editor: null,
      href: {
        title: '',
        link: ''
      },
      isElActive: {
        html: false
      }
    }
  },
  computed: {
    menuActions () {
      return [
        { action: 'html', icon: 'code-square', func: this.viewHtml, hasActive: true },
        { action: 'spacing' },
        { action: 'bold', icon: 'type-bold', hasActive: true },
        { action: 'italic', icon: 'type-italic', hasActive: true },
        { action: 'strike', icon: 'type-strikethrough', hasActive: true },
        { action: 'underline', icon: 'type-underline', hasActive: true },
        { action: 'spacing' },
        { action: 'paragraph', icon: 'paragraph', hasActive: true },
        { action: 'heading', icon: 'type-h1', param: { level: 1 }, hasActive: true },
        { action: 'heading', icon: 'type-h2', param: { level: 2 }, hasActive: true },
        { action: 'heading', icon: 'type-h3', param: { level: 3 }, hasActive: true },
        { action: 'spacing' },
        { action: 'bullet_list', icon: 'list-ul', hasActive: true },
        { action: 'ordered_list', icon: 'list-ol', hasActive: true },
        { action: 'horizontal_rule', icon: 'distribute-vertical' },
        { action: 'href', icon: 'link', func: this.addHrefFrm },
        { action: 'image', icon: 'image', func: this.showImagePrompt, hasActive: false },
        { action: 'spacing' },
        { action: 'undo', icon: 'arrow90deg-left' },
        { action: 'redo', icon: 'arrow90deg-right' }
      ]
    }
  },
  methods: {
    updatedEditor (data) {
    },
    updateValue () {
      this.editor.setContent(this.content);
      this.$emit('input', this.content)
    },
    addHref () {
      let html = '<a href="' + this.href.link + '">';
      if (this.href.title.length > 0) {
        html += this.href.title + '</a>';
      } else {
        html += this.href.link + '</a>';
      }
      this.editor.setContent(this.editor.getHTML() + html);
      this.$refs['modal-href'].hide();
    },
    addHrefFrm () {
      this.href.link = '';
      this.href.title = '';
      this.$refs['modal-href'].show();
    },
    viewHtml () {
      this.setActive('html');
    },
    updateContent (content) {
      this.content = content;
      this.editor.setContent(content);
    },
    setActive (type) {
      this.isElActive[type] = !this.isElActive[type];
    },
    showImagePrompt () {
      this.$refs['modal-image'].show();
    },
    openFileupload () {
      this.$refs.imageFile.$refs.input.click()
    },
    addImage () {
      const files = this.$refs.imageFile.$el.firstChild.files;
      if (files && files.length > 0) {
        const file = files[0];
        const reader = new FileReader();
        const self = this;
        reader.addEventListener('load', function () {
          const src = reader.result;
          self.editor.commands.image({ src })
        }, false);
        if (file) {
          reader.readAsDataURL(file);
        }
      }
      this.$refs['modal-image'].hide();
    }
  },
  mounted () {
    const self = this;
    this.content = this.value;
    this.editor = new Editor({
      editable: !this.disabled,
      extensions: [
        new Blockquote(),
        new CodeBlock(),
        new HorizontalRule(),
        new Heading({ levels: [1, 2, 3] }),
        new BulletList(),
        new OrderedList(),
        new ListItem(),
        new TodoItem(),
        new TodoList(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new Image(),
        new Link()
      ],
      content: this.value,
      onUpdate: function (el) {
        self.content = el.getHTML();
        self.$emit('input', self.content);
      }
    })
  },
  watch: {
    value () {
      if (this.content !== this.value) {
        this.content = this.value;
        this.editor.setContent(this.value);
      }
    },
    disabled () {
      if (this.editor) {
        this.editor.setOptions({ editable: !this.disabled })
      }
    }
  },
  beforeDestroy () {
    this.editor.destroy()
  }
}
